<template>
  <div>
    <span v-if="r_launched">
      {{r_launched['recently_launched_title_' + lang]}}
    </span>
    <span v-if="line">
      {{line['ligne_produit_title_' + lang]}}
    </span>
    <span v-if="body_part">
      {{body_part['title_' + lang]}}
    </span>
    <span v-if="type">
      {{type['type_equipement_title_' + lang]}}
    </span>
    <button v-on:click="remove"></button>
  </div>
</template>

<script>
export default {
  name: "HeaderTag",
  props: ['line', 'body_part','type', 'r_launched'],
  data() {
    return {
      // translation
      lang: window.Store.app.lang
    }
  },
  methods: {
    remove : function(e){
      e.preventDefault();
      this.$emit('remove',this.line, this.body_part, this.type, this.r_launched);
    }
  }
}
</script>

<style scoped>

</style>
